import React, { useEffect, useRef, useCallback, useState } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import { media } from "../Utils/media";
import contactBg from "../Assets/Images/contactBg.jpg";
import { v4 as uuidv4 } from "uuid";
import Loading from "../Components/Loading";
import { fluidFont } from "../Utils/fontSize";

const Contact = () => {
  useEffect(() => {
    AOS.init({});
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const uidRef = useRef(uuidv4());
  const thankYouRef = useRef(null);

  // const getFormData = (form) => {
  //   const elements = form.elements;
  //   let honeypot;

  //   const fields = [...Object.keys(elements)]
  //     .filter((k) => elements[k].name !== "honeypot" || (honeypot = elements[k].value) === undefined)
  //     .map((k) => elements[k].name ?? elements[k].item?.(0)?.name ?? null)
  //     .filter((item, pos, self) => item && self.indexOf(item) === pos);

  //   const formData = fields.reduce((acc, name) => {
  //     const element = elements[name];
  //     acc[name] = element.length
  //       ? [...element]
  //           .filter((item) => item.checked || item.selected)
  //           .map((item) => item.value)
  //           .join(", ")
  //       : element.value;
  //     return acc;
  //   }, {});

  //   return {
  //     data: {
  //       ...formData,
  //       formDataNameOrder: JSON.stringify(fields),
  //       formGoogleSheetName: form.dataset.sheet || "responses",
  //       formGoogleSendEmail: form.dataset.email || "",
  //     },
  //     honeypot,
  //   };
  // };

  // const disableAllButtons = (form) => form.querySelectorAll("button").forEach((btn) => (btn.disabled = true));

  const handleFormSubmit = useCallback(async (event) => {
    setIsLoading(true);
    event.preventDefault();
    const form = event.currentTarget;

    // 스팸 방지(honeypot)
    const honey = form.querySelector('input[name="honeypot"]')?.value;
    if (honey) return false;

    // 버튼 비활성화
    form.querySelectorAll("button").forEach((btn) => (btn.disabled = true));

    // 간단/안정 직렬화: FormData -> URLSearchParams
    const fd = new FormData(form);

    // 메타 필드(시트 이름/이메일) 세팅
    if (!fd.get("formGoogleSheetName")) {
      fd.set("formGoogleSheetName", form.dataset.sheet || "responses");
    }
    if (!fd.get("formGoogleSendEmail")) {
      fd.set("formGoogleSendEmail", form.dataset.email || "");
    }

    // 필드 순서 기록(선택)
    const order = Array.from(form.elements)
      .map((el) => el.name)
      .filter(Boolean);
    fd.set("formDataNameOrder", JSON.stringify(order));

    // GAS가 urlencoded를 받도록 통일
    const body = new URLSearchParams();
    for (const [k, v] of fd.entries()) body.append(k, v);

    try {
      const res = await fetch(form.action, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
        // CORS가 막혀도 제출은 되게 할 거라면 다음 줄을 고려:
        // mode: "no-cors",
      });

      // no-cors면 status 확인이 불가하므로 바로 성공 처리
      if (res.ok || res.type === "opaque") {
        form.reset();
        uidRef.current = uuidv4(); // 다음 제출 대비 새 uid
        if (thankYouRef.current) thankYouRef.current.style.display = "block";
      } else {
        alert("제출에 실패했어요. 잠시 후 다시 시도해주세요.");
      }
    } catch (e) {
      alert("네트워크 오류가 발생했어요. 잠시 후 다시 시도해주세요.");
    } finally {
      form.querySelectorAll("button").forEach((btn) => (btn.disabled = false));
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      {isLoading && <Loading />}
      <PageContainer>
        <PageWrapper>
          <SectionTop>
            <SectionTopTitleArea>
              <SectionTopTitleContainer>
                <SectionTopTitleCopy data-aos="fade-right" data-aos-delay="200" data-aos-duration="1400">
                  CONTACT US
                </SectionTopTitleCopy>
              </SectionTopTitleContainer>
            </SectionTopTitleArea>
            <SectionTopBG />
          </SectionTop>
          <Section1Container>
            <Wrapper>
              <Section1TextArea data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                <Section1TopTitleCopy>함께 미래 만들기</Section1TopTitleCopy>
                <Section1TopMainCopy>
                  당신의 <span style={{ fontWeight: "700" }}>'Concept'</span>는 무엇인가요? <br />
                  <span style={{ fontWeight: "700" }}>지디피 스튜디오</span>와 함께 놀라운 <span style={{ fontWeight: "700" }}>'Tomorrow'</span>를 만들어보세요.
                </Section1TopMainCopy>
              </Section1TextArea>
            </Wrapper>
          </Section1Container>
          <Section2Container>
            <Wrapper>
              <Section2TitleCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                문의하기
              </Section2TitleCopy>
              <Section2FormArea data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                <form
                  action="https://script.google.com/macros/s/AKfycbw8C0CMbEmUSK_cXWmOnwlcq3Ta2kBKBjeD6g-VMA17pC_0Dy8p4b0SlCczjzkeIOlv/exec"
                  method="POST"
                  data-email="andy@certifie.io"
                  onSubmit={handleFormSubmit}
                  style={{ margin: 0, padding: 0, border: "none" }}
                  name="fwrite"
                  id="contact"
                  autoComplete="off"
                  encType="application/x-www-form-urlencoded"
                  data-sheet="responses"
                >
                  <input type="text" name="honeypot" tabIndex="-1" autoComplete="off" style={{ position: "absolute", left: "-9999px" }} />
                  <input type="hidden" name="uid" value={uidRef.current}></input>
                  <input type="hidden" name="device" value={isMobile ? "mobile" : "pc/tablet"}></input>
                  {/* <input type="hidden" name="w" value=""></input>
                <input type="hidden" name="bo_table" value="inquiry"></input>
                <input type="hidden" name="html" value="html1"></input>
                <input type="hidden" name="wr_email" value="admin@concept2x.co.kr"></input>
                <input type="hidden" name="wr_subject" value="[CONCEPT2X] 상담문의가 접수 되었습니다."></input>
                <input type="hidden" name="ret" value="/contact"></input> */}
                  {isMobile ? (
                    <Section2FormWrapperMobile>
                      <Section2FormTitleCopy>기본정보</Section2FormTitleCopy>
                      <Section2FormItem>
                        <Section2FormLabelCopy>회사명 / 개인명</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="text" placeholder="회사명/개인명을 입력해주세요." required name="companyName"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem>
                        <Section2FormLabelCopy>담당자명</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="text" placeholder="담당자명을 입력해주세요." required name="representative"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem>
                        <Section2FormLabelCopy>연락처 (전화번호)</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="text" placeholder="‘-’  구분 없이 숫자만 입력해주세요." required name="telNumb"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem>
                        <Section2FormLabelCopy>이메일 주소</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="email" placeholder="‘@’를 포함한 이메일 주소를 입력해주세요." required name="email"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem2>
                        <Section2FormLabelCopy>문의내용</Section2FormLabelCopy>
                        <Section2FormTextAreaContainer>
                          <Section2FormTextArea placeholder="문의하고 싶은 내용을 입력해 주세요." required name="content"></Section2FormTextArea>
                        </Section2FormTextAreaContainer>
                      </Section2FormItem2>
                      <Section2FormTermArea>
                        <Section2FormLabelCopy>개인정보 수집 및 이용동의</Section2FormLabelCopy>
                        <Section2FormTermText>
                          1. 수집하는 개인정보의 항목
                          <br />
                          - 필수항목 : 카테고리, 회사명, 이름, 연락처, E-mail
                          <br />
                          - 선택항목 : <br />
                          <br />
                          2. 개인정보의 수집 및 이용 목적
                          <br />
                          - 가. 상담 및 컨설팅 운영, 귀사 및 제휴업체의 재화 또는 서비스, 콘텐츠 제공 등 맞춤 서비스 제공 목적
                          <br />
                          - 나. 민원 사무 처리: 서비스 제공에 관한 계약 이행 및 불만 처리 등 민원 처리, 고지 사항 전달, 분쟁 조정을 위한 기록
                          <br />
                          <br />
                          3. 개인정보의 처리 및 보유기간
                          <br />
                          - 개인정보 처리 및 보유 기간 : 법정의무 보유기간 또는 동의 철회시
                          <br />
                          ※ 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 법령에서 규정한 보존 기간 동안 최소한의 기본 정보를 보유
                          <br />※ 보유기간을 정보주체에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 정보주체의 동의를 받은 경우에는 약속한
                          보유기간동안 보유
                        </Section2FormTermText>
                        <Section2FormCheckArea>
                          <Section2FormCheckInput type="checkbox" id="term_agree" required></Section2FormCheckInput>
                          <Section2FormCheckLabel htmlFor="term_agree">개인정보 수집 및 이용에 동의합니다.</Section2FormCheckLabel>
                        </Section2FormCheckArea>
                      </Section2FormTermArea>
                    </Section2FormWrapperMobile>
                  ) : (
                    <Section2FormWrapper>
                      <Section2FormTitleCopy>기본정보</Section2FormTitleCopy>
                      <Section2FormItem>
                        <Section2FormLabelCopy>회사명 / 개인명</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="text" placeholder="회사명/개인명을 입력해주세요." required name="companyName"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem>
                        <Section2FormLabelCopy>담당자명</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="text" placeholder="담당자명을 입력해주세요." required name="representative"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem>
                        <Section2FormLabelCopy>연락처 (전화번호)</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="text" placeholder="‘-’  구분 없이 숫자만 입력해주세요." required name="telNumb"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem>
                        <Section2FormLabelCopy>이메일 주소</Section2FormLabelCopy>
                        <Section2FormItem>
                          <Section2FormInput type="email" placeholder="‘@’를 포함한 이메일 주소를 입력해주세요." required name="email"></Section2FormInput>
                        </Section2FormItem>
                      </Section2FormItem>
                      <Section2FormItem2>
                        <Section2FormLabelCopy>문의내용</Section2FormLabelCopy>
                        <Section2FormTextAreaContainer>
                          <Section2FormTextArea placeholder="문의하고 싶은 내용을 입력해 주세요." required name="content"></Section2FormTextArea>
                        </Section2FormTextAreaContainer>
                      </Section2FormItem2>
                      <Section2FormTermArea>
                        <Section2FormLabelCopy>개인정보 수집 및 이용동의</Section2FormLabelCopy>
                        <Section2FormTermText>
                          1. 수집하는 개인정보의 항목
                          <br />
                          - 필수항목 : 카테고리, 회사명, 이름, 연락처, E-mail
                          <br />
                          - 선택항목 : <br />
                          <br />
                          2. 개인정보의 수집 및 이용 목적
                          <br />
                          - 가. 상담 및 컨설팅 운영, 귀사 및 제휴업체의 재화 또는 서비스, 콘텐츠 제공 등 맞춤 서비스 제공 목적
                          <br />
                          - 나. 민원 사무 처리: 서비스 제공에 관한 계약 이행 및 불만 처리 등 민원 처리, 고지 사항 전달, 분쟁 조정을 위한 기록
                          <br />
                          <br />
                          3. 개인정보의 처리 및 보유기간
                          <br />
                          - 개인정보 처리 및 보유 기간 : 법정의무 보유기간 또는 동의 철회시
                          <br />
                          ※ 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 법령에서 규정한 보존 기간 동안 최소한의 기본 정보를 보유
                          <br />※ 보유기간을 정보주체에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 정보주체의 동의를 받은 경우에는 약속한
                          보유기간동안 보유
                        </Section2FormTermText>
                        <Section2FormCheckArea>
                          <Section2FormCheckInput type="checkbox" id="term_agree" required></Section2FormCheckInput>
                          <Section2FormCheckLabel htmlFor="term_agree">개인정보 수집 및 이용에 동의합니다.</Section2FormCheckLabel>
                        </Section2FormCheckArea>
                      </Section2FormTermArea>
                    </Section2FormWrapper>
                  )}
                  <Section2FormThankCopy ref={thankYouRef}>연락주셔서 감사합니다. 빠른 시일 내에 답변 드리겠습니다.</Section2FormThankCopy>
                  <Section2FormButtonArea>
                    <Section2FormButton type="submit">문의하기</Section2FormButton>
                  </Section2FormButtonArea>
                </form>
              </Section2FormArea>
            </Wrapper>
          </Section2Container>
        </PageWrapper>
      </PageContainer>
    </>
  );
};

const PageContainer = styled.div`
  display: block;
  background-color: #000000;
  overflow-x: hidden;
`;

const PageWrapper = styled.div`
  display: block;
  box-sizing: border-box;
`;

const SectionTop = styled.div`
  display: block;
  position: relative;
  box-sizing: border-box;
  ${media.web`
      margin-top: 240px;
  `}
  ${media.mobile`
      margin-top: 136px;
  `}
`;

const SectionTopTitleArea = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(-50%);
`;

const SectionTopTitleContainer = styled.div`
  width: 100%;
  max-width: 1470px;
  padding: 0 20px;
  margin: 0 auto;
`;

const SectionTopTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  line-height: 1.1;
  ${media.web`
      font-size: ${fluidFont(72, 100)};
  `}
  ${media.mobile`
      font-size: 42px;
  `}
`;

const SectionTopBG = styled.div`
  background-attachment: fixed;
  background: url(${contactBg}) no-repeat center / cover;
  background-image: url(${contactBg});
  width: 100%;
  box-sizing: border-box;
  ${media.web`
    height:500px;
  `};
  ${media.mobile`
    background-size: 200%;
    background-position: right center;
    height:320px;
  `};
`;

const Section1Container = styled.div`
  display: block;
  box-sizing: border-box;
  ${media.web`
    padding-top: 200px;
  `}
  ${media.mobile`
    padding-top: 80px;
  `}
`;

const Wrapper = styled.div`
  display: block;
  box-sizing: border-box;
  width: 100%;
  max-width: 1540px;
  padding: 0 20px;
  margin: 0 auto;
`;

const Section1TextArea = styled.div`
  text-align: center;
  margin: 0;
`;

const Section1TopTitleCopy = styled.div`
  color: #3da7ff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  line-height: 1.4;
  ${media.web`
      font-size: ${fluidFont(16, 24)};
      margin-bottom: 12px;
  `}
  ${media.mobile`
      font-size: 16px;
      margin-bottom: 12px;
  `}
`;

const Section1TopMainCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  line-height: 1.35;
  ${media.web`
      font-size: ${fluidFont(32, 64)};
  `}
  ${media.mobile`
      font-size: 32px;
  `}
`;

const Section2Container = styled.div`
  display: block;
  overflow-x: hidden;
  box-sizing: border-box;
  ${media.web`
    padding: 140px 0 200px;
  `}
  ${media.mobile`
    padding: 140px 0 ;
  `}
`;

const Section2TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  text-align: center;
  font-weight: 700;
  line-height: 1.4;
  ${media.web` 
      font-size: ${fluidFont(32, 48)};
      margin-bottom:80px;
  `}
  ${media.mobile`
      font-size: 24px;
      margin-bottom:40px;
  `}
`;

const Section2FormArea = styled.div`
  display: block;
  box-sizing: border-box;
`;

const Section2FormWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: linear-gradient(140deg, rgba(84, 79, 79, 0.2), rgba(84, 79, 79, 0.05));
  box-sizing: border-box;
  ${media.web`
    gap: 40px 20px;
    padding: 60px 80px;
    border-radius: 20px;
  `}
`;

const Section2FormWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  background: linear-gradient(140deg, rgba(84, 79, 79, 0.2), rgba(84, 79, 79, 0.05));
  box-sizing: border-box;
  ${media.mobile`
    border-radius: 10px;
        gap: 20px;
        padding: 34px 16px;
  `}
`;

const Section2FormTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 600;
  ${media.web`
    grid-column: span 2;
    font-size: 32px;
  `}
  ${media.mobile`
    font-size: 20px;
  `}
`;

const Section2FormItem = styled.div`
  display: block;
  box-sizing: border-box;
`;

const Section2FormLabelCopy = styled.div`
  display: block;
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 600;
  ${media.web`
    font-size: 18px;
    margin-bottom: 14px;
  `}
  ${media.mobile`
    font-size: 14px;
    margin-bottom: 12px;
  `}
`;

const Section2FormInput = styled.input`
  background: #222222;
  box-sizing: border-box;
  border: solid 1px transparent;
  transition: all 0.2s;
  color: #ffffff;
  width: 100%;
  ${media.web`
    height: 60px;
    border-radius: 10px;
    font-size: 17px;
    padding: 0 20px;
  `}
  ${media.mobile`
    height: 40px;
    border-radius: 5px;
    font-size: 14px;
    padding: 0 14px;
  `}
`;

const Section2FormItem2 = styled.div`
  display: block;
  grid-column: span 2;
  box-sizing: border-box;
`;

const Section2FormTextAreaContainer = styled.div`
  display: block;
  box-sizing: border-box;
`;

const Section2FormTextArea = styled.textarea`
  color: #ffffff;
  background: #222222;
  box-sizing: border-box;
  border: solid 1px transparent;
  transition: all 0.2s;
  line-height: 1.5;
  ${media.web`
    width: 100%;
    height: 200px;
    border-radius: 10px;
    font-size: 17px;
    padding: 20px;
  `}
  ${media.mobile`
    width: 100%;
    height: 150px;
    border-radius: 5px;
    font-size: 14px;
    padding: 16px;
  `}
`;

const Section2FormTermArea = styled.div`
  grid-column: span 2;
  display: block;
  box-sizing: border-box;
  border-top: solid 1px #535353;
  padding-top: 40px;
`;

const Section2FormTermText = styled.div`
  background: #222222;
  font-family: "Pretendard";
  font-style: normal;
  color: rgba(255, 255, 255, 0.5);
  border: solid 1px transparent;
  overflow-y: auto;
  box-sizing: border-box;
  width: 100%;
  ${media.web`
    height: 200px;
    border-radius: 10px;
    font-size: 17px;
    padding: 20px;
  `}
  ${media.mobile`
    height: 150px;
    border-radius: 5px;
    font-size: 14px;
    padding: 12px;
    line-height:1.35;
  `}

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: #535353;
    border-radius: 50px;
  }

  &::-webkit-scrollbar-track {
    background-color: #2e2e2e;
    border-radius: 50px;
  }

  scrollbar-width: thin;
  scrollbar-color: #535353 #2e2e2e;
`;

const Section2FormCheckArea = styled.div`
  display: block;
  box-sizing: border-box;
  margin-top: 20px;
`;

const Section2FormCheckLabel = styled.label`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  display: block;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: 600;
  padding-left: 28px;

  &::before {
    content: "";
    display: block;
    width: 18px;
    height: 18px;
    border: solid 1px rgba(255, 255, 255, 0.7);
    border-radius: 4px;
    position: absolute;
    top: 2px;
    left: 0;
  }

  input:checked + &::before {
    background: white;
    border-color: white;
    content: "✓"; /* or use background image */
    color: black;
    font-size: 14px;
    text-align: center;
    line-height: 18px;
  }
`;

const Section2FormCheckInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  color: #fff;
  letter-spacing: -0.02em;
  margin: 0;
  padding: 0;
  outline: 0;
  resize: none;
  box-sizing: border-box;
  background-color: initial;
  cursor: default;
  appearance: auto;
`;

const Section2FormButtonArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 10px;
  margin-top: 40px;
`;

const Section2FormButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(140deg, rgba(84, 79, 79, 0.4), rgba(84, 79, 79, 0.1));
  border: solid 1px rgba(255, 255, 255, 0.25);

  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  ${media.web`
    gap: 0 10px;
    font-size: 18px;
    font-weight: 700;
    border-radius: 100px;
    backdrop-filter: blur(30px);
    padding: 20px 50px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, .2);
  `}
  ${media.mobile`
    gap: 0 10px;
    font-size: 18px;
    font-weight: 700;
    border-radius: 100px;
    backdrop-filter: blur(30px);
    padding: 20px 50px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, .2);
  `}

  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-color: #3da7ff;
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.2s;
    opacity: 0;
  }
`;

const Section2FormThankCopy = styled.div`
  display: none;
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-size: 18px;
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: center;
`;

export default Contact;
